import ListaMensagem from './ListaMensagem'

export default ListaMensagem